import Vue from 'vue'
import Router from 'vue-router'
import { mapCommonRouter } from '@/pages/common'
import { route } from '@/utils/build'
import sa from 'sa-sdk-javascript'

Vue.use(Router)
/**
 * 路由注册
 */
const router = new Router({
  routes: [
    ...mapCommonRouter,
    // 默认外部打开 app
    route('/share-default', 'shareDefault', resolve => require(['@/pages/share/views/share-default/index'], resolve)),
    // 后台课程分享
    route('/share-course', 'shareCourse', resolve => require(['@/pages/share/views/share-course/index'], resolve)),
    // 后台直播分享
    route('/share-live', 'shareLive', resolve => require(['@/pages/share/views/share-live/index'], resolve)),
    // 课程分享
    route('/course-share', 'courseShare', resolve => require(['@/pages/share/views/course-share'], resolve)),
    // 课程详情
    route('/course-detail', 'courseDetail', resolve => require(['@/pages/share/views/course-detail'], resolve)),
    // 录音分享
    route('/record-share', 'recordShare', resolve => require(['@/pages/share/views/record-share'], resolve)),
    // 小程序分享
    route('/mini-app', 'miniApp', resolve => require(['@/pages/share/views/mini-app'], resolve)),
    // 小程序分享
    route('/show-pictures', 'showPictures', resolve => require(['@/pages/share/views/show-pictures'], resolve)),
    // 小程序分享
    route('/show-pictures2', 'showPictures2', resolve => require(['@/pages/share/views/show-pictures2'], resolve)),
    // 优惠券分享
    route('/share-coupons', 'share-coupons', resolve => require(['@/pages/share/views/share-coupons'], resolve)),
    // 申请短信图片
    route('/apply-code', 'apply-code', resolve => require(['@/pages/share/views/apply-code'], resolve), {
      meta: { title: '夏鹏·中文精读特训营' }
    }),
    // 夏鹏英语学习法
    route('/apply-study', 'apply-study', resolve => require(['@/pages/share/views/apply-study'], resolve), {
      meta: { title: '夏鹏英语学习法' }
    }),
    // 夏鹏·中文书单精选课
    route('/apply-select', 'apply-select', resolve => require(['@/pages/share/views/apply-select'], resolve), {
      meta: { title: '夏鹏·中文书单精选课' }
    }),
    // 线下日历二维码扫描进入的页面
    route('/calendar-code', 'calendar-code', resolve => require(['@/pages/share/views/calendar-code'], resolve)),
    // 积分拉新活动二维码扫描进入的页面
    route('/call', 'call', resolve => require(['@/pages/share/views/call/call'], resolve)),
    route('/call_log', 'call_log', resolve => require(['@/pages/share/views/call/call-log'], resolve)),
    //根据用户身份自动跳转
    route('/golink', 'golink', resolve => require(['@/pages/share/views/golink'], resolve)),
    route('/golinkto', 'golinkto', resolve => require(['@/pages/share/views/golinkto'], resolve)),
    // 日历二维码
    route('/calendarQr', 'calendarQr', resolve => require(['@/pages/share/views/qr/calendarQr'], resolve)),
    //体验营课程列表
    route('/camp-course-list', 'camp-course-list', resolve =>
      require(['@/pages/share/views/camp-course-list/index.vue'], resolve)
    ),
    route('/course-level-list', 'course-level-list', resolve =>
      require(['@/pages/share/views/camp-course-list/course-level-list.vue'], resolve)
    ),
    route('/course-level-commit', 'course-level-commit', resolve =>
      require(['@/pages/share/views/camp-course-list/course-level-commit.vue'], resolve)
    ),
    route('/share-album', 'share-album', resolve => require(['@/pages/share/views/share-album/index.vue'], resolve))
  ]
})
router.beforeEach((to, from, next) => {
  /* 路由发生变化修改页面title */
  console.log(to)
  if (to.meta.title) {
    document.title = to.meta.title
  }
  next()
})
router.afterEach((to, from) => {
  // 路由切换完成后触发神策页面浏览事件
  Vue.nextTick(() => {
    if (document.title === '友邻少年') return
    if (typeof sa !== 'undefined') {
      sa.quick('autoTrack')
    }
  })
})
export default router
